module.exports = __webpack_public_path__ + "media/images/mailer/vpn_key-48-primary-b7d1e5a20f9d8eec5b4c6576ffd6eabe.png";